// src/redux/createEvent/createActions/fetchGetItems.js

import apiClient from "../../../apiClient/apiClient";
import {
  GET_CREATE_EVENT_ITEMS_FAILURE,
  GET_CREATE_EVENT_ITEMS_REQUEST,
  GET_CREATE_EVENT_ITEMS_SUCCESS
} from "../createConstant/GetCreateConsant";

/**
 * Action creator to fetch events and assign category names to each event.
 */
export const fetchGetItems = (page = 1, pageSize = 100) => async (dispatch) => {
  dispatch({
    type: GET_CREATE_EVENT_ITEMS_REQUEST
  });

  try {
    const token = localStorage.getItem("access") || sessionStorage.getItem("access");
    const config = token ? {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    } : {};

    // Collect all events
    let allEvents = [];
    let totalCount = 0;
    let nextPageUrl = `/events/?page=${page}&page_size=${pageSize}`;
    
    // Keep fetching while there's a next page
    while (nextPageUrl) {
      console.log(`Fetching: ${nextPageUrl}`);
      const response = await apiClient.get(nextPageUrl);
      const data = response.data;
      
      // Add these results to our collection
      if (Array.isArray(data.results)) {
        allEvents = [...allEvents, ...data.results];
        console.log(`Added ${data.results.length} events. Total now: ${allEvents.length}`);
      }
      
      // Update total count and next page URL
      totalCount = data.count || totalCount;
      
      // Check if there's another page to fetch
      if (data.next) {
        // If next is a full URL, extract just the path
        const url = new URL(data.next);
        nextPageUrl = url.pathname + url.search;
      } else {
        nextPageUrl = null;
      }
    }
    
    console.log(`Finished loading. Total events loaded: ${allEvents.length} of ${totalCount}`);

    // Fetch categories
    const categoryResponse = await apiClient.get("/category/");
    const categories = categoryResponse?.data?.results || [];
    
    // Create category map
    const categoryMap = {};
    categories.forEach(category => {
      categoryMap[category.category_id] = category.category_name;
    });

    // Enhance events with category names
    const enhancedEvents = allEvents.map(event => ({
      ...event,
      category_name: categoryMap[event.category] || "Unknown Category"
    }));

    dispatch({
      type: GET_CREATE_EVENT_ITEMS_SUCCESS,
      payload: {
        results: enhancedEvents,
        count: totalCount,
        currentPage: page
      }
    });

  } catch (error) {
    console.error("Error fetching events:", error);
    dispatch({
      type: GET_CREATE_EVENT_ITEMS_FAILURE,
      payload: error.response?.data?.message || error.message
    });
  }
};

// Just use the regular function with a higher page size
export const fetchAllEvents = () => fetchGetItems(1, 100);
